var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"text-2xl mb-6"},[_vm._v("Propinas por formas de pago")]),_c('ReporteArqueoCajaPropina',{attrs:{"filtrosShow":true,"exportar":['EXCEL','PDF']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }